export const DurationView = Backbone.View.extend({
  initialize: function (context) {
    this.searchView = context;
    this.setElement(context.$el);
    this.temporaryModel = context.temporaryModel;
    this.wordings = SEARCH_SCRIPTS.WORDING_SEARCH;
    this.indexButtonSelected = false;
    this.initDurationValue();
    this.initListener();
    this.updateAvailability();
  },

  initDurationValue: function () {
    const durationList = SEARCH_SCRIPTS.DURATION_CP ? JSON.parse(SEARCH_SCRIPTS.DURATION_CP) : [];

    let selectedValue = false;

    for (let i = 2; i < 15; i++) {
      if (typeof durationList[i] !== 'undefined' && durationList[i].selected) {
        if (selectedValue && selectedValue < 10) {//il peut y avoir plusieurs value selected au dessus de 10, mais pas plusieurs value "visibles"
          selectedValue = false;
          return false;
        } else {
          selectedValue = i < 10 ? i : 10;
        }
      }
    }

    if (selectedValue) {
      this.indexButtonSelected = selectedValue;
      this.temporaryModel.set({'duration': selectedValue}, {'silent': true});
      this.searchView.model.set({'duration': selectedValue}, {'silent': true});
    }
  },

  initListener: function () {
    this.stopListening(dispatcher, 'duration:render');
    this.listenTo(dispatcher, 'duration:render', this.renderDuration);

    this.stopListening(dispatcher, 'duration:handleLoader');
    this.listenTo(dispatcher, 'duration:handleLoader', this.handleLoader);

    this.stopListening(dispatcher, 'duration:updateAvailability');
    this.listenTo(dispatcher, 'duration:updateAvailability', this.updateAvailability);

    this.stopListening(dispatcher, 'duration:updateDurationValues');
    this.listenTo(dispatcher, 'duration:updateDurationValues', this.updateDurationValues);
  },

  updateDurationValues: function (durationValues) {
    SEARCH_SCRIPTS.DURATION_CP = JSON.stringify(durationValues);
    dispatcher.trigger('facette:flexPeriod:updateMonths');
  },

  // FLEX_PERIOD
  updateAvailability: function () {
    const $selectedMonth = $('.js-flexMonths .js-selectPeriod.active');
    const selectedMonth = $selectedMonth.length ? $selectedMonth.data('month').toString() : false;
    const durationList = SEARCH_SCRIPTS.DURATION_CP ? JSON.parse(SEARCH_SCRIPTS.DURATION_CP) : false;

    if (selectedMonth && durationList) {
      $.each(durationList, (key, item) => {
        const $duration = $(`.js-durationButton_${key}`);
        $duration.toggleClass('u-disabled', !item.months.includes(selectedMonth));
      });
    } else {
      $('.js-durationButton').toggleClass('u-disabled', !durationList || durationList.length === 0);
    }
  },

  renderDuration: function () {
    const $pika = $('.pika-single.is-bound').not('.is-hidden'),
      htmlDuration = this.templateDuration(),
      datepickerType = $pika.hasClass('arrival') ? 'arrival' : $pika.hasClass('departure') ? 'departure' : 'none';

    $('.js-searchForm-durationContainer').html(htmlDuration);
    //init button action after delay to let html be inserted in html
    setTimeout(() => {
      this.initDurationAction(datepickerType);
    }, 500);
  },

  initDurationAction: function (datepickerType) {
    //*** GESTION DES COMPORTEMENTS ***//
    const durationEventSelect = !DEVICE.isDesktop ? 'click.durationEvent touchend.durationEvent' : 'click.durationEvent';
    const $durationBtn = $('.js-durationButton');

    $durationBtn.off().on('click', event => {
      const $button = $(event.currentTarget);
      const selectDuration = !$button.hasClass('selected'); //si bouton déjà sélectionné, on déselectionnes
      const duration = selectDuration ? $button.data('value') : null;
      const flexPeriodSelected = this.temporaryModel.get('isFlexPeriod');
      const modelDatas = {'duration': duration};

      //-- Clean strict dates
      if (!flexPeriodSelected) {
        modelDatas.arrivalDate = null;
        modelDatas.departureDate = null;
        dispatcher.trigger('facette:flexPeriod:cleanFixDates');
        dispatcher.trigger('search:updateMainSearchStore', 'date', null);
        dispatcher.trigger('search:updateMainSearchStore', 'dateend', null);
      }

      this.temporaryModel.set(modelDatas);

      if (!DEVICE.isMobile && duration !== null) {
        $('.js-search-flexPeriod').addClass('opened');
      }

      // -- handling storedSearchParams
      let storedDatas = [];

      if (duration === 10) {
        for (let i = 10; i < 15; i++) {
          storedDatas.push({'key': i, 'value': i});
        }
      } else {
        storedDatas = duration ? [{'key': duration, 'value': duration}] : null;
      }

      dispatcher.trigger('search:updateMainSearchStore', 'duration', storedDatas);
      dispatcher.trigger('facette:flexPeriod:updateEngineField');
    });
  },

  // Display loader on the pika tooltip
  handleLoader: function (display = true) {
    const $calendarContainer = DEVICE.isMobile ? $('#mobileCalendar') : $('#mainCalendar-datePicker');

    $('#pika-backgroundLoader').remove();

    if (display && $calendarContainer.length) {
      const htmlBackgroundLoader = `
        <div id="pika-backgroundLoader" class="pika-backgroundLoader" style="width:${$calendarContainer.outerWidth()}px;height:${$calendarContainer.outerHeight()}px;top:${$calendarContainer.offset().top}px;left:${$calendarContainer.offset().left}px">
          <div class="pika-loader">
            <div class="cp-spinner">
              <i></i>
            </div>
          </div>
        </div>`;
      $('body').append(htmlBackgroundLoader);
    } else {
      $('.pika-loader').remove();
    }
  },

  templateDuration: function () {
    const durationList = SEARCH_SCRIPTS.DURATION_CP ? JSON.parse(SEARCH_SCRIPTS.DURATION_CP) : false,
      pageTemplate = PAGE_SCRIPTS.page_template,
      duration_unik = SEARCH_SCRIPTS.DURATION_CP_UNIK;

    let htmlDurationList = '',
      htmlDuration = '';

    if (durationList) {
      if (duration_unik) {
        let durationSelected = null;

        for (let i = 2; i < 11; i++) {
          if (typeof durationList[i] !== 'undefined' && durationList[i].default) {
            durationSelected = i;
            this.indexButtonSelected = i;
          }
        }

        const wordingDurationUnik = typeof this.wordings.duration_unik === 'string' ? this.wordings.duration_unik.replace('%XX', durationSelected) : '';
        htmlDuration = `
          <div class="searchForm-durationContainer">
            <div class="searchForm-durationUnik">${wordingDurationUnik}</div>
          </div>`;
      } else {
        //test valeurs par défaut
        const arrDefaultValues = SEARCH_SCRIPTS.DURATION_DEFAULT ? JSON.parse(SEARCH_SCRIPTS.DURATION_DEFAULT) : [];
        let nbSelectedDuration = 0;

        if (arrDefaultValues.length) {
          //rule : sur les sck, on envoie les valeurs paramétrées par défaut si aucune durée n'est choisie => il ne faut pas les remonter comme selected
          for (let i = 2; i < 10; i++) {
            if (typeof durationList[i] !== 'undefined' && durationList[i].selected) {
              nbSelectedDuration++;
            }
          }
        }

        let isWeekend = false;
        const durationModel = this.temporaryModel.get('duration');
        const duration = durationModel && typeof durationModel !== 'undefined' ? durationModel : '';
        isWeekend = duration === 'weekend';

        htmlDurationList += `
          <li class="js-durationButton js-durationButton_weekend searchForm-durationItem${isWeekend ? ' selected' : ''} js-Tracking--link"
            data-tracking='{"clickCode":"","gaCategory":"${pageTemplate}","gaAction":"Flex calendar-duration","gaLabel":"weekend","event":"clickEvent"}'
            data-value="weekend">
            <span class="searchForm-durationButton">${this.wordings.weekend}</span>
          </li>`;

        const gaClickCode = '';
        const gaAction = 'Flex calendar-duration';
        const gaEvent = '"event": "clickEvent"';

        for (let i = 2; i < 10; i++) {
          /*** rules :
           - duration non définie dans le tableau => inactive
           - duration définie mais non sélectionnée => active
           - duration définie, selected mais les deux dates sont définies => selected et inactive
           - duration définie, avec seulement date d'arrivée ou sans => selected
           ***/
          let statusClass = typeof durationList[i] !== 'undefined' && durationList[i].enabled ? durationList[i].selected && nbSelectedDuration < 2 ? ' selected' : '' : ' u-disabled';

          if (statusClass === ' selected') {
            this.indexButtonSelected = i;
          }

          htmlDurationList += `
            <li class="js-durationButton js-durationButton_${i} searchForm-durationItem${statusClass} js-Tracking--link"
              data-tracking='{"clickCode":"${gaClickCode}","gaCategory":"${pageTemplate}","gaAction":"${gaAction}","gaLabel":"${i} nights",${gaEvent}}'
              data-value="${i}">
              <span class="searchForm-durationButton">${i}</span>
            </li>`;
        }

        let tenMoreIsEnabled = false,
          tenMoreIsSelected = false;
        for (let i = 10; i < 15; i++) {
          if (typeof durationList[i] !== 'undefined' && durationList[i].enabled) {
            tenMoreIsEnabled = true;
            if (durationList[i].selected) {
              tenMoreIsSelected = true;
            }
          }
        }

        const tenMoreStatusClass = tenMoreIsEnabled ? tenMoreIsSelected && nbSelectedDuration === 0 ? ' selected' : '' : ' u-disabled';
        if (tenMoreIsSelected) {
          this.indexButtonSelected = 10;
        }

        htmlDurationList += `
          <li class="searchForm-durationItem${tenMoreStatusClass} js-durationButton js-durationButton_10 js-Tracking--link"
              data-tracking='{"clickCode":"${gaClickCode}","gaCategory":"${pageTemplate}","gaAction":"${gaAction}","gaLabel":"10+ nights",${gaEvent}}'
              data-value="10">
              <span class="searchForm-durationButton">10+</span>
            </li>`;

        htmlDuration = `<p class="searchForm-durationLabel"><span class="searchForm-durationLabel--main">${this.wordings.duration_main_label}</span> ${this.wordings.duration_main_label_option}</p>
        <div id="js-durationList" class="searchForm-durationListContainer">
          <ul class="searchForm-durationList">
              ${htmlDurationList}
          </ul>
        </div>`;
      }

      return htmlDuration;
    }
  }
});